module.exports = __webpack_public_path__ + "static/media/trta.a0f3aa9e.png";